import * as React from 'react';
import { FC } from 'react';

import Dialog from 'components/dialog';
import { t } from 'state/intl/translations';

import {
  CloseButton,
  ConfirmButton,
  DialogContent,
  DialogIconContainer,
  DialogTitle,
  ErrorIcon,
  ModalActionsContainer,
} from './styled';

type UnlinkWalmartUserModalProps = {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const UnlinkWalmartUserModal: FC<React.PropsWithChildren<UnlinkWalmartUserModalProps>> = ({
  open,
  onConfirm,
  onClose,
}) => {
  const handleConfirm = () => {
    onClose();
    onConfirm();
  };

  return (
    <Dialog
      showDialog={open}
      headingComponent={<DialogTitle>{t('walmartUnlinkTitleDialog')}</DialogTitle>}
      bodyComponent={<DialogContent>{t('walmartUnlinkBodyDialog')}</DialogContent>}
      onDismiss={onClose}
      modalAppearanceEventMessage="Walmart+ unlink user modal"
      image={
        <DialogIconContainer>
          <ErrorIcon />
        </DialogIconContainer>
      }
      actions={
        <ModalActionsContainer>
          <ConfirmButton onPress={handleConfirm}>
            {t('walmartUnlinkConfirmBtnDialog')}
          </ConfirmButton>
          <CloseButton onPress={onClose}>{t('walmartUnlinkCancelBtnDialog')}</CloseButton>
        </ModalActionsContainer>
      }
    />
  );
};
